module.exports = __webpack_public_path__ + "static/media/pic_logo.47c33255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/utils/images/originals/pic_logo.png
// module id = 130
// module chunks = 0